// @flow
import React from 'react';
import ListItemText from "@mui/material/ListItemText";
import {Switch} from "@mui/material";
import ListItem from "@mui/material/ListItem";
import type {Exhibition} from "../../../../../../types/exhibition/types";
import {useTranslation} from "react-i18next";
import {EXHIBITION} from "../../../../../../locales/components/namespaces";
import {Update} from "../../../../../../hooks/exhibitions/useExhibitionAction";

type Props = {
	id: string,
	exhibition: Exhibition,
	updateExhibition: Function
};

const DisplayFreeAdvertisementToExhibitor = (props: Props) => {
	const {t} = useTranslation(EXHIBITION)
	const {id, exhibition, updateExhibition} = props
	
	const toggleDisplay = () => {
		updateExhibition(id, !exhibition.displayFreeAdvertisementToExhibitor, Update.ExhibitorFreeAdvertisement)
	}
	return (
		<ListItem>
			<ListItemText
				primary={t('Display Free Advertisement Tab To Exhibitor')}
				secondary={t('If you disable this, then exhibitors will not be able to access free advertisement from their profile.')}
			/>
			<Switch
				edge="end"
				onChange={toggleDisplay}
				checked={exhibition.displayFreeAdvertisementToExhibitor}
			/>
		</ListItem>
	);
};

export default DisplayFreeAdvertisementToExhibitor